import styled, { css } from "styled-components";
import { Atom } from 'AppReact';

const DayText = styled.div`
  ${({ theme, displayState }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 14.28%;
    height: 34px;
    font-size: 14px;
    border-radius: 50%;
    cursor: pointer;
    &:hover {
      font-weight: 600;
    }
    
    color: ${displayState.selected ? '#FFFFFF' : '#444'};
    background-color: ${displayState.inSelectedPeriod ? `${theme?.colour?.primary}40` : displayState.selected && (theme?.colour?.primary ?? '#1DBD6B')};
    
    ${displayState?.inSelectedPeriod && css`
      background-color: ${`${theme?.colour?.primary}40`};
      border-radius: 0px;
    `}

    ${displayState?.roundedLeft && css`
      border-radius: 50% 0px 0px 50%;
      background-color: ${theme?.colour?.primary ?? '#1DBD6B'};
      color: #FFFFFF;
      font-weight: 600;
    `}

    ${displayState?.roundedRight && css`
      border-radius: 0px 50% 50% 0px;
      background-color: ${theme?.colour?.primary ?? '#1DBD6B'};
      color: #FFFFFF;
      font-weight: 600;
    `}

    font-weight: ${displayState.selected ? 600 : 400};

    ${displayState.disabled && css`
      color: #AAA;
      cursor: not-allowed;
    `}
  `}
`;

export default Atom({ type: 'button', dataType: 'string', template: DayText })